import * as React from 'react';

export default function CardTrackingIcon() {
	return (
		<svg
			className="m-card__figure-tracking"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="45px"
			height="45px"
			viewBox="0 0 45 45"
			enableBackground="new 0 0 45 45"
			xmlSpace="preserve"
		>
			<g>
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					d="M4.5,17.397v12.12c0,2.352,5.262,4.257,11.751,4.257h23.016c0.681,0,1.233-0.558,1.233-1.239v-9.094c0-0.684-0.547-1.239-1.236-1.239H17.506"
				/>
				<ellipse
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					cx="17.51"
					cy="16.726"
					rx="13.001"
					ry="5.5"
				/>
				<ellipse
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					cx="17.299"
					cy="16.771"
					rx="6.501"
					ry="2"
				/>
				<line
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					x1="30.516"
					y1="17.004"
					x2="30.516"
					y2="21.911"
				/>
				<line
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					x1="35.662"
					y1="29.518"
					x2="35.662"
					y2="33.618"
				/>
				<line
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					x1="26.774"
					y1="29.518"
					x2="26.774"
					y2="33.618"
				/>
				<line
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					x1="17.888"
					y1="29.518"
					x2="17.888"
					y2="33.618"
				/>
				<line
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					x1="9"
					y1="28.202"
					x2="9"
					y2="32.303"
				/>
				<line
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					x1="31.218"
					y1="31.303"
					x2="31.218"
					y2="33.617"
				/>
				<line
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					x1="22.331"
					y1="31.303"
					x2="22.331"
					y2="33.617"
				/>
				<line
					fill="none"
					stroke="currentColor"
					strokeWidth="1.0"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit="10"
					x1="13.443"
					y1="31.303"
					x2="13.443"
					y2="33.617"
				/>
			</g>
		</svg>
	);
}
